import { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';
import Button from 'components/atoms/button';
import FormContent from 'components/organisms/formContent';
import FormCol from 'components/molecules/formCol';
import FormHr from 'components/atoms/formHr';
import FormTextField from 'components/molecules/formTextField/index.jsx';
import ArrowLink from 'components/atoms/arrowLink';
import LinkingPos from '../payment/LinkinPos';
import serviceHelper from 'helpers/service';

class Congratulations extends Component {
  render() {
    const { brand, services, brandId, legacy_service, addons } = this.props;
    let price = services.reduce((total, service) => (serviceHelper.price(service, { legacy_service }) + total), 0);
    if (addons) {
      price += addons.reduce((total, service) => (serviceHelper.price(service, { legacy_service }) + total), 0);
    }

    return (
      <div className="review">
        <Header />

        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Te esperamos pronto</h2>

              <FormContent small>
                <FormCol single center>
                  <div className="shiftInfo">
                    <FormTextField
                      label="Código del turno"
                      type="text"
                      inline
                      size="s"
                      value={this.props.code}
                      center
                      readonly
                    />
                    <FormHr />
                    <p>
                      En unos minutos recibirás un email con los datos. Si necesitás cambiar el
                      horario o cancelar el turno podés llamarnos al 0261 4439300.
                    </p>
                    <FormHr />
                    {price > 0 && (
                      <>
                        <div className="noprint">
                          <h4>Pagá tu turno online</h4>
                          <p>Ganale a la inflación pagando tu turno online.</p>
                          <p>Haciendo ahora el pago de tu turno de taller, mantendremos el precio congelado
                            hasta el día de tu turno. De lo contrario, podría estar sujeto a actualizaciones.
                          </p>
                          <LinkingPos amount={price} code={`${this.props.code}-shift`} brandId={brandId} />
                        </div>
                        <div className="noprint">
                          <Button
                            className="noprint"
                            buttonText="Imprimir turno"
                            onClick={() => window.print()}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </FormCol>
              </FormContent>
              <div className="noprint">
                <p className="s">
                  {brand === 'vw' && (
                    <ArrowLink size="small" style="blue" href="https://vwyacopini.com.ar">
                      Volver a Yacopini Süd
                    </ArrowLink>
                  )}
                  {brand === 'gm' && (
                    <ArrowLink size="small" style="blue" href="https://yacopinigm.com.ar">
                      Volver a Yacopini Motors
                    </ArrowLink>
                  )}
                  {brand === 'nissan' && (
                    <ArrowLink size="small" style="blue" href="https://yacopininissan.com.ar">
                      Volver a Yacopini Nissan
                    </ArrowLink>
                  )}
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const selector = formValueSelector('shiftRequest');

const mapStateToProps = state => {
  return {
    code: state.shifts.code,
    brand: state.configuration.brand,
    services: selector(state, 'services'),
    addons: selector(state, 'addons'),
    brandId: state.configuration.brand_id,
    legacy_service: selector(state, 'legacy_service'),
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Congratulations);
